<template>
  <mp-avatar :size="size" :src="avatarUrl" :name="name" />
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    url: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    hasPath: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
  computed: {
    avatarUrl() {
      if (!this.hasPath) return `${this.$imgPath}${this.url}`;
      return this.url;
    },
  },
};
</script>
